import { render, staticRenderFns } from "./vat-review-section.vue?vue&type=template&id=2439ca83&scoped=true&lang=pug"
import script from "./vat-review-section.vue?vue&type=script&lang=ts"
export * from "./vat-review-section.vue?vue&type=script&lang=ts"
import style0 from "./vat-review-section.vue?vue&type=style&index=0&id=2439ca83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439ca83",
  null
  
)

export default component.exports